// extracted by mini-css-extract-plugin
export default {"countryTable":"styles_countryTable__Qfay2","headerWrapper":"styles_headerWrapper__LhfsV","contentWrapper":"styles_contentWrapper__rnlZj"};